import {
  Container,
  Page,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useTeam } from '@foxtrotplatform/platform-micro-site-core';
import React, { useEffect, useState } from 'react';

import { RequireUserOrg } from '../../common/auth/RequireOrg';
import { OrganizationCheck } from '../Organization';
import { SelectCreateTeamCard } from './SelectCreateTeamCard';
import { UserTeamTable } from './UserTeamTable';

export const Team: React.FunctionComponent = (): JSX.Element | null => {
  const { refreshTeams } = useTeam();
  const [isSubmitting, setIsSubmitting] = useState<boolean>();

  useEffect(() => {
    const refresh = async () => {
      if (isSubmitting) {
        await refreshTeams();
      }
    };
    refresh();
  }, [isSubmitting]);

  return (
    <RequireUserOrg>
      <Page>
        <Container size="medium">
          <OrganizationCheck />
          <UserTeamTable />
          <SelectCreateTeamCard onSubmitting={setIsSubmitting} />
        </Container>
      </Page>
    </RequireUserOrg>
  );
};
